import { z } from "zod";

export const orderPageSearchParamsSchema = z.object({
  from: z.enum(["create"]).optional().catch(undefined),
});

export type OrderPageSearchParams = z.infer<typeof orderPageSearchParamsSchema>;
